import { Component, OnInit, DoCheck } from "@angular/core";
import { AppConfig } from "@app/core/Utilities/app-config.service";
import { CookieService } from "ngx-cookie-service";
import { AuthenticationService } from "@app/core/services/authentication.service";
import { Router } from "@angular/router";
import { ManageRecommendationsComponent } from "@app/modules/agent/pages/manage-recommendations/manage-recommendations.component";
import { BsModalRef, BsModalService } from "ngx-bootstrap/modal";
import { NotificationService } from "@app/core/services/notification.service";
import { NotificationComponent } from "@app/modules/message-center/pages/notification/notification.component";
import { DomSanitizer } from "@angular/platform-browser";
import { ApiService } from "@app/core";
import { ChatService, SignalRService } from "@app/core/services/chat.service";
import { MessageCenterService } from "@app/core/services/message-center.service";
import { AgentDetailComponent } from '@app/modules/agent/pages/agent-detail/agent-detail.component';
import { WhatIsNewComponent } from '@app/modules/home/pages/what-is-new/what-is-new.component';
import { HelperService } from '@app/core/services/helper.service';

@Component({
  selector: "app-header-menu",
  templateUrl: "./header-menu.component.html",
  styleUrls: ["./header-menu.component.scss"],
})
export class HeaderMenuComponent implements OnInit, DoCheck {
  subModalRef: BsModalRef;
  hideSearch = false;
  bsModalRef: BsModalRef;
  loginDisplay = false;
  constructor(
    public authService: AuthenticationService,
    public appConfig: AppConfig,
    public router: Router,
    private modalService: BsModalService,
    private notificationService: NotificationService,
    private sanit: DomSanitizer,
    private apiService: ApiService,
    public chatService: ChatService,
    private messageCenterService: MessageCenterService,
    private helperService: HelperService,
    private cookieService: CookieService,
    private signalRService: SignalRService
  ) { }

  public isAdmin: boolean = false;
  public displayMobileHeader = false;

  ngOnInit() {
    if (this.appConfig.SharedComponent.userLoggedIn) {
      this.notificationService.updateNotificationCount();
      this.messageCenterService.updateInboxCount();
    }
    this.hideSearch = this.router.url === '/' || this.router.url.includes("/?env=") || this.router.url.includes("YOURPROFILE");
    if (this.router.url.includes("YOURPROFILE")) {
      this.viewProfile();
    }

    this.authService.initializeMsalService();
    this.checkoutAccount();
  }
                
  checkoutAccount() {
    this.loginDisplay = this.authService.isUserLoggedIn();             
  }
         
  ngDoCheck() {
    if (window.localStorage.getItem("isAdmin") == "true") {
      this.isAdmin = true;        
    } else {
      this.isAdmin = false;                    
    }
  }          
                 
  login() {
    this.authService.login();
  }                  

  logout() {
    this.authService.logout();
  }

  beforeLogout() {
    this.cookieService.deleteAll("/");
    window.localStorage.removeItem("agentBasicDetails");
    window.localStorage.removeItem("isAdmin");
    window.localStorage.setItem("showMlsID", "false");
    window.localStorage.removeItem("agentProfileInfo");
    this.appConfig.SharedComponent.userLoggedIn = false;
    this.appConfig.SharedComponent.loggedInUserInfo = null;
    this.appConfig.SharedComponent.notificationCount = 0;
    this.appConfig.SharedComponent.inboxCount = 0;
    this.chatService.SharedChatComponent.userActiveChat = [];
    this.chatService.SharedChatComponent.userArchiveChat = [];
    this.appConfig.SharedComponent.isWhatIsNewVisible = false;
    this.signalRService.stopConnection();
  }

  openNotifications() {
    this.modalService.config.class = "modal-md";
    this.subModalRef = this.modalService.show(NotificationComponent, {
      backdrop: "static",
    });
    this.subModalRef.content.closeBtnName = "Close";
  }

  manageRecommendation() {
    this.displayMobileHeader = false;
    this.subModalRef = this.modalService.show(
      ManageRecommendationsComponent,
      { backdrop: "static", class: "modal-lg" }
    );
    this.subModalRef.content.closeBtnName = "Close";
  }

  showMobileMainNav() {
    this.displayMobileHeader = !this.displayMobileHeader;
  }

  onResize(event) {
    this.displayMobileHeader = false;
  }

  getImgsSanitized(imageURL: any) {
    if (imageURL) {
      return this.sanit.bypassSecurityTrustStyle(
        "url(" + imageURL + "), url(/assets/images/user-icon.png)"
      );
    } else {
      return this.sanit.bypassSecurityTrustStyle(
        "url(/assets/images/user-icon.png)"
      );
    }
  }

  getImgSanitized(imageURL: any) {
    if (imageURL) {
      return this.sanit.bypassSecurityTrustUrl(imageURL);
    } else {
      return this.sanit.bypassSecurityTrustUrl("./assets/images/user-icon.png");
    }
  }

  setLoginUser() {
    this.apiService
      .get(this.appConfig.GetUrl("getLoginUser"))
      .subscribe((result) => {
        this.appConfig.SharedComponent.loggedInUserInfo = result;
        if (this.router.url.includes("YOURPROFILE") && this.appConfig.SharedComponent.userLoggedIn) {
          this.viewProfile();
        }
      });
  }

  editProfile() {
    window.open("https://crs.com/dashboard/myprofile.aspx", "_blank");
  }

  viewProfile() {
    if (this.authService.isUserLoggedIn() &&
      !this.helperService.isUndefinedOrNullOrEmpty(+this.authService.getUserInformation()["ID"])) {
      const agentID = +this.authService.getUserInformation()["ID"];
      if (agentID > 0) {
        const initialState = {
          agentId: agentID,
        };

        this.bsModalRef = this.modalService.show(AgentDetailComponent, {
          initialState,
          backdrop: 'static',
          class: "modal-xl",
        });
        this.bsModalRef.content.closeBtnName = "Close";
      }
    }
  }

  openWhatsNew() {
    const initialState = {
      isForAll: true,
    };
    this.modalService.show(WhatIsNewComponent, { initialState, backdrop: "static", class: 'modal-md whatNew-modal' });
  }
}
